import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {useAuthStore} from '../../store/authStore';

function Login() {
    const login = useAuthStore((state) => state.login);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            await login({email, password});
            navigate('/account');
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="w-full flex justify-center bg-gradient-to-r from-blue-300 via-white to-green-100 rounded-lg py-10">
        <div className="container py-5 rounded-lg bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900" style={{maxWidth: '420px'}}>
            <h1 className="text-2xl font-semibold leading-tight text-blue-800 mb-4">Log in</h1>

            {error && <div className="text-red-600 mb-3">{error}</div>}

            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="loginEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" required value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder="Enter email"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="loginPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" required value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="Password"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Button variant="primary" type="submit" disabled={submitting}
                        className="bg-blue-200 border-blue-200 text-blue-900">
                    {submitting ? 'Logging in...' : 'Log in'}
                </Button>
            </Form>

            <p className="mt-3 text-sm text-gray-600">
                Don't have an account? <a href="/register" className="text-blue-600">Register</a>
            </p>
        </div>
        </div>
    );
}

export default Login;
